(() => {
  const KEY = 'bulken-bkn-index-v4';
  const TTL = 6 * 60 * 60 * 1000;
  const MIN = 3;
  let indexPromise = null;
 
  const norm = (s) => String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const asList = (v) => (Array.isArray(v) ? v : v ? [v] : []).map(String).filter(Boolean);
 
  const fetchPage = async (page) => {
    const r = await fetch(`/collections/all?view=bkn-index&page=${page}`, { credentials: 'same-origin' });
    return JSON.parse(await r.text());
  };
 
  const prepare = (items) =>
    items.map((x) => {
      const b = asList(x.b);
      const s = asList(x.s);
      return { t: x.t, u: x.u, i: x.i, p: x.p, b, s, kb: b.map(norm), ks: s.map(norm) };
    });
 
  const load = () => {
    if (indexPromise) return indexPromise;
    indexPromise = (async () => {
      try {
        const c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (c && Date.now() - c.ts < TTL) return c.items;
      } catch (e) {}
      const first = await fetchPage(1);
      const rest = [];
      for (let p = 2; p <= first.pages; p++) rest.push(fetchPage(p));
      const pages = [first, ...(await Promise.all(rest))];
      const items = prepare(pages.flatMap((d) => d.items || []));
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), items }));
      } catch (e) {}
      return items;
    })().catch(() => {
      indexPromise = null;
      return [];
    });
    return indexPromise;
  };
 
  const score = (keys, q) => {
    let best = 9;
    for (const k of keys) {
      if (!k) continue;
      if (k === q) return 0;
      if (k.startsWith(q)) best = Math.min(best, 1);
      else if (k.includes(q)) best = Math.min(best, 2);
    }
    return best;
  };
 
  const find = async (query, { limit = 10, fields = 'both' } = {}) => {
    const q = norm(query);
    if (q.length < MIN) return [];
    const items = await load();
    const out = [];
    for (const it of items) {
      const sb = fields === 'sku' ? 9 : score(it.kb, q);
      const ss = fields === 'bkn' ? 9 : score(it.ks, q);
      const r = Math.min(sb, ss);
      if (r < 9) out.push({ ...it, rank: r, via: sb <= ss ? 'bkn' : 'sku' });
    }
    out.sort((a, b) => a.rank - b.rank || a.t.localeCompare(b.t));
    return limit ? out.slice(0, limit) : out;
  };
 
  const exact = async (query) => {
    const q = norm(query);
    if (q.length < MIN) return null;
    const hits = (await find(query, { limit: 0 })).filter((x) => x.rank === 0);
    return hits.length === 1 ? hits[0] : null;
  };
 
  window.BulkenBKN = { load, find, exact };
 
  const isSearchForm = (f) => f && f.querySelector('input[name="q"]') && /\/search/.test(f.getAttribute('action') || '/search');
 
  document.addEventListener(
    'focusin',
    (e) => {
      if (e.target.matches && e.target.matches('input[name="q"]')) load();
    },
    true
  );
 
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!isSearchForm(form) || form.dataset.bknPass) return;
      const q = form.querySelector('input[name="q"]').value.trim();
      if (norm(q).length < MIN) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const fallback = () => {
        form.dataset.bknPass = '1';
        HTMLFormElement.prototype.submit.call(form);
      };
      const timer = setTimeout(fallback, 2500);
      exact(q)
        .then((hit) => {
          clearTimeout(timer);
          if (hit) window.location.href = hit.u;
          else fallback();
        })
        .catch(() => {
          clearTimeout(timer);
          fallback();
        });
    },
    true
  );
 
  const css = `
.bkn-matches{box-sizing:border-box;max-width:1200px;margin:24px auto 32px;padding:0 20px;font-size:14px;line-height:1.4}
.bkn-matches *{box-sizing:border-box}
.bkn-matches h2{font-size:20px;line-height:1.2;margin:0 0 16px;letter-spacing:.02em}
.bkn-matches h2 span{font-size:14px;font-weight:400;opacity:.6;margin-left:8px;text-transform:none;letter-spacing:0}
.bkn-matches ul{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:repeat(auto-fill,minmax(170px,1fr));gap:16px}
.bkn-matches li{margin:0;min-width:0}
.bkn-matches a{display:flex;flex-direction:column;height:100%;padding:12px;border:1px solid #e3e3e3;border-radius:6px;text-decoration:none;color:inherit;background:#fff;transition:border-color .15s,box-shadow .15s}
.bkn-matches a:hover{border-color:#32431D;box-shadow:0 2px 8px rgba(0,0,0,.08)}
.bkn-matches .img{width:100%;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;margin-bottom:10px;background:#fafafa;border-radius:4px;overflow:hidden}
.bkn-matches img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;display:block}
.bkn-matches .t{font-size:13px;line-height:1.35;font-weight:500;margin:0 0 8px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;overflow-wrap:anywhere}
.bkn-matches .c{font-size:12px;color:#C93D1B;font-weight:700;margin:auto 0 4px;overflow-wrap:anywhere}
.bkn-matches .p{font-size:14px;font-weight:600;margin:0}
@media (max-width:600px){.bkn-matches ul{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}.bkn-matches a{padding:8px}}`;
 
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
 
  const renderSearchPage = async () => {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    const params = new URLSearchParams(location.search);
    const q = params.get('q') || '';
    if ((params.get('page') || '1') !== '1' || norm(q).length < MIN) return;
    const hits = (await find(q, { limit: 48, fields: 'bkn' })).filter((h) => score(h.ks, norm(q)) === 9);
    if (!hits.length) return;
    const onPage = new Set(
      [...document.querySelectorAll('main a[href*="/products/"]')].map((a) => new URL(a.href, location.origin).pathname)
    );
    const fresh = hits.filter((h) => !onPage.has(new URL(h.u, location.origin).pathname));
    if (!fresh.length) return;
    const style = el('style');
    style.textContent = css;
    document.head.appendChild(style);
    const wrap = el('section', 'bkn-matches');
    const h2 = el('h2', null, 'Part number matches');
    h2.appendChild(el('span', null, `${fresh.length} result${fresh.length === 1 ? '' : 's'}`));
    wrap.appendChild(h2);
    const ul = el('ul');
    for (const h of fresh) {
      const li = el('li');
      const a = el('a');
      a.href = h.u;
      const box = el('div', 'img');
      if (h.i) {
        const img = el('img');
        img.src = h.i;
        img.alt = h.t;
        img.loading = 'lazy';
        box.appendChild(img);
      }
      a.appendChild(box);
      a.appendChild(el('p', 't', h.t));
      a.appendChild(el('p', 'c', h.b.join(', ')));
      if (h.p) a.appendChild(el('p', 'p', h.p));
      li.appendChild(a);
      ul.appendChild(li);
    }
    wrap.appendChild(ul);
    const main = document.querySelector('main') || document.body;
    main.insertBefore(wrap, main.firstChild);
  };
 
  const ddCss = `
.bkn-dd,.bkn-dd *{box-sizing:border-box;margin:0;padding:0;text-align:left;letter-spacing:normal;text-transform:none}
.bkn-dd{position:fixed;z-index:2147483000;background:#fff;border-top:3px solid #32431D;box-shadow:0 10px 28px rgba(0,0,0,.18);max-height:70vh;overflow:auto;font-size:14px;line-height:1.35;padding:4px 0;color:#1a1a1a;font-family:inherit}
.bkn-dd .hd{display:block;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#777;padding:10px 16px 6px}
.bkn-dd a.row{display:flex;gap:12px;align-items:center;padding:8px 16px;text-decoration:none;color:inherit}
.bkn-dd a.row:hover,.bkn-dd a.row:focus,.bkn-dd a.row.on{background:#f4f5f1;outline:none}
.bkn-dd .im{flex:none;width:52px;height:52px;display:flex;align-items:center;justify-content:center;background:#fafafa;border-radius:4px;overflow:hidden}
.bkn-dd .im img{max-width:100%;max-height:100%;object-fit:contain;display:block}
.bkn-dd .tx{display:block;min-width:0;flex:1}
.bkn-dd .t{font-size:13px;font-weight:500;margin-bottom:3px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.bkn-dd .c{display:block;font-size:12px;font-weight:700;color:#C93D1B}
.bkn-dd .p{flex:none;font-size:13px;font-weight:600;padding-left:8px;white-space:nowrap}
.bkn-dd a.all{display:block;padding:10px 16px;border-top:1px solid #eee;font-size:13px;font-weight:600;color:#32431D;text-decoration:none}
.bkn-dd a.all:hover{text-decoration:underline}`;
 
  const VERSION = '4';
  let dd = null;
  let ddInput = null;
  let ddStyled = false;
  let active = -1;
  let timer = null;
  let seq = 0;
 
  const ensureStyle = () => {
    if (ddStyled) return;
    const s = el('style');
    s.textContent = ddCss;
    document.head.appendChild(s);
    ddStyled = true;
  };
 
  const place = () => {
    if (!dd || !ddInput) return;
    const r = ddInput.getBoundingClientRect();
    if (!r.width) return hide();
    dd.style.left = `${r.left}px`;
    dd.style.top = `${r.bottom + 6}px`;
    dd.style.width = `${Math.max(r.width, 320)}px`;
  };
 
  const hide = () => {
    if (dd) dd.remove();
    dd = null;
    active = -1;
  };
 
  const show = (input, q, hits) => {
    ensureStyle();
    hide();
    ddInput = input;
    dd = el('div', 'bkn-dd');
    dd.setAttribute('role', 'listbox');
    dd.appendChild(el('div', 'hd', 'Part number matches'));
    for (const h of hits) {
      const a = el('a', 'row');
      a.href = h.u;
      a.setAttribute('role', 'option');
      const im = el('div', 'im');
      if (h.i) {
        const img = el('img');
        img.src = h.i;
        img.alt = '';
        img.loading = 'lazy';
        im.appendChild(img);
      }
      const tx = el('div', 'tx');
      tx.appendChild(el('div', 't', h.t));
      const code = h.via === 'sku' ? h.s.find((x) => norm(x).includes(norm(q))) || h.s[0] : h.b.join(', ');
      tx.appendChild(el('div', 'c', code || ''));
      a.appendChild(im);
      a.appendChild(tx);
      if (h.p) a.appendChild(el('div', 'p', h.p));
      dd.appendChild(a);
    }
    const all = el('a', 'all', `See all results for “${q}”`);
    all.href = `/search?q=${encodeURIComponent(q)}`;
    dd.appendChild(all);
    dd.addEventListener('mousedown', (e) => e.preventDefault());
    document.body.appendChild(dd);
    place();
  };
 
  const run = async (input) => {
    const id = ++seq;
    const q = input.value;
    if (norm(q).length < MIN) return hide();
    const hits = await find(q, { limit: 8 });
    if (id !== seq || input.value !== q) return;
    if (!hits.length) return hide();
    show(input, q, hits);
  };
 
  const isQ = (t) => t && t.matches && t.matches('input[name="q"]');
 
  document.addEventListener(
    'input',
    (e) => {
      if (!isQ(e.target)) return;
      clearTimeout(timer);
      const input = e.target;
      timer = setTimeout(() => run(input), 120);
    },
    true
  );
 
  document.addEventListener(
    'focusin',
    (e) => {
      if (isQ(e.target) && norm(e.target.value).length >= MIN) run(e.target);
    },
    true
  );
 
  document.addEventListener(
    'focusout',
    (e) => {
      if (isQ(e.target)) setTimeout(() => {
        if (!dd) return;
        if (document.activeElement === ddInput || dd.contains(document.activeElement)) return;
        hide();
      }, 150);
    },
    true
  );
 
  document.addEventListener(
    'keydown',
    (e) => {
      if (!dd || !isQ(e.target)) return;
      const rows = [...dd.querySelectorAll('a.row')];
      if (e.key === 'Escape') return hide();
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = e.key === 'ArrowDown' ? Math.min(active + 1, rows.length - 1) : Math.max(active - 1, -1);
        rows.forEach((r, i) => r.classList.toggle('on', i === active));
        if (rows[active]) rows[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && rows[active]) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = rows[active].href;
      }
    },
    true
  );
 
  document.addEventListener(
    'mousedown',
    (e) => {
      if (dd && !dd.contains(e.target) && e.target !== ddInput) hide();
    },
    true
  );
 
  window.addEventListener('scroll', place, { passive: true, capture: true });
  window.addEventListener('resize', place);
 
  window.BulkenBKN.version = VERSION;
  window.BulkenBKN.debug = async (q) => {
    const input = document.querySelector('input[name="q"]');
    const query = q || (input && input.value) || '';
    const items = await load();
    const hits = await find(query, { limit: 8 });
    const info = { version: VERSION, indexed: items.length, withBKN: items.filter((x) => x.b.length).length, query, hits: hits.map((h) => `${h.b.join(',') || h.s[0]} | ${h.t}`) };
    console.log('[BulkenBKN]', info);
    return info;
  };
 
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderSearchPage);
  else renderSearchPage();
})();